import { queryOptions, useQuery } from '@tanstack/react-query';

import { seoApi } from '../api/seo-api';

import { seoKeys } from './seo-keys';

/** The last 20 runs; a queued run shows up once the worker starts it. */
export function seoAuditsQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: seoKeys.audits(storeId),
    queryFn: () => seoApi.audits(storeId),
  });
}

export function useSeoAudits(storeId: string) {
  return useQuery(seoAuditsQueryOptions(storeId));
}
